export default __webpack_public_path__ + "images/43c78c79a58be98427b404cb58b1b1b4-food_and_drink_mobile-2.webp";